// extracted by mini-css-extract-plugin
module.exports = {"socialMediaContainer":"SocialMediaLinks-module--socialMediaContainer--3YX0V","socialMedia":"SocialMediaLinks-module--socialMedia--lU5NJ"};